export function isValidURL(url: string): boolean {
  if (!url) {
    return false
  }
  if (!url.startsWith('https://')) {
    return false
  }

  try {
    new URL(url)
    return true
  } catch (_) {
    return false
  }
}
